import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const POSTER = "https://customer-assets-7cd3h4nn.emergentagent.net/job_golden-wolf-premium/artifacts/0ag6fthu_WhatsApp%20Image%202026-09-01%20at%2021.43.26.jpeg";

export default function LeaderOfThePack() {
  return (
    <section className="section bg-ink relative overflow-hidden" data-testid="leader-of-the-pack">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 items-center">
          {/* Poster — sized well for phone */}
          <motion.div
            initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, ease: [0.22,1,0.36,1] }}
            className="md:col-span-6 order-2 md:order-1"
          >
            <div className="relative aspect-square max-w-[560px] mx-auto rounded-3xl overflow-hidden border border-gold/40 shadow-[0_40px_80px_-30px_rgba(201,162,75,0.4)]">
              <img src={POSTER} alt="Toriano Sanzone — Leader of the Pack" className="w-full h-full object-cover"/>
              <div className="absolute inset-0 pointer-events-none" style={{ boxShadow: "inset 0 0 100px rgba(0,0,0,0.4)" }}/>
            </div>
          </motion.div>

          <div className="md:col-span-6 order-1 md:order-2">
            <div className="text-eyebrow text-gold">Leader of the Pack</div>
            <h2 className="mt-4 font-display text-[clamp(2.2rem,6vw,5.8rem)] leading-[0.92] tracking-[-0.03em]">
              Building empires.<br/>
              Raising standards.<br/>
              <span className="italic gold-foil">Changing lives.</span>
            </h2>
            <p className="mt-6 max-w-xl text-bone/80 text-lg font-editorial italic">
              The Wolfkeeper universe — dog training, leadership, wealth consciousness — one man carrying the entire pack forward.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/books-media" className="btn-gold" data-testid="lop-book">Consciousness of Abundance</Link>
              <Link to="/dog-training" className="btn-outline" data-testid="lop-training">Train with Toriano</Link>
            </div>
            <div className="mt-8 flex items-center gap-6 text-hair text-bone/60">
              <span>Dog Training</span>
              <span className="text-gold">·</span>
              <span>Leadership</span>
              <span className="text-gold">·</span>
              <span>Wealth Consciousness</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
